<script setup lang="ts">
  import Highcharts from 'highcharts'
  import { Chart } from 'highcharts-vue'

  // exportingInit(Highcharts)
  // accessibility(Highcharts)

  defineProps<{
    constructorType: 'stockChart' | 'chart' | 'mapChart',
    options: Highcharts.Options,
  }>()
</script>

<template>
  <chart
    class="highcharts-light"
    :options="options" />
</template>
